import { useState, useEffect } from 'react';
import { makeStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';
import Container from '@mui/material/Container';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { save } from './api-atividade';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { addAtividades, updateAtividades } from './actions/actions';
import { setAtividade as setAtividadeRedux } from './actions/actions';
import Grid from '@mui/material/Grid';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import CloseIcon from '@mui/icons-material/Close';
import CircularProgress from '@mui/material/CircularProgress';
import { errorMessage } from '../../util/ConfirmAlertUtil';
import SunEditorUI from '../UI/SunEditorUI';
import TextFieldDate from '../UI/TextFieldDate';
import TextFieldDateTime from '../UI/TextFieldDateTime';
import dayjs from 'dayjs';

const useStyles = makeStyles({
    paper: {
        marginTop: "20px"
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        // marginTop: theme.spacing(1),
    },
    title: {
        flex: '1 1 100%',
        paddingTop: '20px;'
    },
    submit: {
        // margin: theme.spacing(3, 0, 2),
    },
    closeIcon: {
        marginTop: '20px',
        marginBottom: '20px',
        cursor: 'pointer'
    },
    loading: {
        marginRight: '10px',
        marginLeft: '10px'
    }
});

export default function AtividadeForm() {
    const classes = useStyles();
    const atividadeRedux = useSelector(state => state.atividade);
    const tdp = useSelector(state => state.atividade);
    const [atividade, setAtividade] = useState({
        tdp: tdp
    });
    const [isLoadingSave, setIsLoadingSave] = useState(false);

    useEffect(() => {
        setAtividade(atividadeRedux);
    }, [atividadeRedux])

    const dispatch = useDispatch();

    const handleChange = (event) => {
        setAtividade({
            ...atividade,
            [event.target.name]: event.target.value
        })
    }

    const handleChangeConteudo = (value) => {
        setAtividade((prevState) => ({
            ...prevState,
            conteudo: value.replace(/[\u200B-\u200D\uFEFF]/g, '')
        }))
    }

    const handleDataChange = (data) => {
        // if (data)
        //     data.setHours(0, 0, 0, 0);

        setAtividade({
            ...atividade,
            data: dayjs(data)
        })
    }

    const clickSubmit = (event) => {
        event.preventDefault();
        setIsLoadingSave(true);
        const codAtividade = atividade.codigo;
        save(atividade).then(data => {
            if (data) {
                if (data.error) {
                    errorMessage(data.message);
                } else {
                    toast.success("Salvo com sucesso.", {
                        position: "bottom-left"
                    });
                    if (codAtividade) {
                        dispatch(updateAtividades(data));
                    } else {
                        dispatch(addAtividades(data));
                    }
                    dispatch(setAtividadeRedux(null));
                }
            }
            setIsLoadingSave(false);

        }).catch(err => {
            console.log(err);
        })

    }

    const handleSwitchChange = name => event => {
        setAtividade((prevState) => ({
            ...prevState,
            [name]: event.target.checked
        }));
    };


    const handleDataLimiteEntregaChange = (dataLimiteEntrega) => {

        setAtividade({
            ...atividade,
            dataLimiteEntrega: dataLimiteEntrega
        })
    }


    return (
        <Container className={classes.paper} component={Paper}>
            <Grid container justifyContent="space-between">
                <Grid size={3}>
                    <CloseIcon
                        onClick={() => dispatch(setAtividadeRedux(null))}
                        className={classes.closeIcon}
                        fontSize='small'
                    />
                </Grid>
            </Grid>
            <form onSubmit={clickSubmit}>
                <div>
                    <TextFieldDate
                        required
                        label="Data"
                        value={atividade && atividade.data ? atividade.data : null}
                        onChange={handleDataChange}

                    />
                    <TextField
                        size='small'
                        variant="outlined"
                        margin="normal"
                        fullWidth
                        required
                        label="Descrição"
                        name="descricao"
                        onChange={handleChange}
                        value={atividade && atividade.descricao ? atividade.descricao : ''}
                        slotProps={{
                            htmlInput: { maxLength: 100 }
                        }}
                    />
                    <SunEditorUI
                        onChange={handleChangeConteudo}
                        content={atividade && atividade.conteudo ? atividade.conteudo : ''}
                    />

                    <FormControlLabel
                        control={
                            <Switch
                                checked={atividade && atividade.semNota ? true : false}
                                onChange={handleSwitchChange('semNota')}
                                value={atividade && atividade.semNota ? true : false}
                            />
                        }
                        label="Sem nota"
                    />
                    <FormControlLabel
                        control={
                            <Switch
                                checked={atividade && atividade.entrega ? true : false}
                                onChange={handleSwitchChange('entrega')}
                                value={atividade && atividade.entrega ? true : false}
                            />
                        }
                        label="Entrega"
                    />
                    <div>
                        {atividade && atividade.entrega ?
                            <TextFieldDateTime
                                size='small'
                                ampm={false}
                                required
                                variant="outlined"
                                margin="normal"
                                label="Data Limite Entrega"
                                value={atividade && atividade.dataLimiteEntrega ? atividade.dataLimiteEntrega : null}
                                onChange={handleDataLimiteEntregaChange}
                                KeyboardButtonProps={{
                                    'aria-label': 'change time',
                                }}
                            />
                            : ''}
                    </div>
                </div>
                <Button
                    type="submit"
                    variant="contained"
                    disabled={isLoadingSave}
                    color="primary"
                    className={classes.submit}>
                    {isLoadingSave && <CircularProgress className={classes.loading} color="primary" size={20} />}
                    Salvar
                </Button>
            </form>
        </Container>
    );
}